module.exports = __webpack_public_path__ + "img/log_black.91491d0e.png";